<form [formGroup]="form">
  <div class="form-group ">
    <label class="form-label" for="TopicTheme">{{ 'lang.globals.name' | translate }}</label>
    <input type="text" id="TopicTheme" class="form-control " formControlName="TopicTheme" sbAutofocus [maxLength]="250">
    <span class="form-text text-muted">{{ 'lang.planningEdit.nameDescription' | translate }}</span>
    <div *ngIf="TopicTheme.touched && TopicTheme.errors?.required"
         class="alert alert-danger">{{ 'lang.planningEdit.nameWarning' | translate }}
    </div>
  </div>
  <div class="form-group ">
    <label class="form-label" for="TopicText">{{ 'lang.globals.description' | translate }}</label>
    <textarea type="text" id="TopicText" class="form-control" formControlName="TopicText"
              rows="4"></textarea>
    <span class="form-text text-muted">{{ 'lang.planningEdit.description' | translate }}</span>
    <div *ngIf="TopicText.touched && TopicText.errors?.required"
         class="alert alert-danger">{{ 'lang.planningEdit.description' | translate }}
    </div>
  </div>
  <div class="tw-flex tw-justify-between tw-w-full">
    <button (click)="cancelTopic($event)" type="reset"
            class="btn btn-default btn-lg btn-wide">{{ 'lang.globals.cancel' | translate }}
    </button>
    <button (click)="topicSubmission($event)" type="submit" [disabled]="!form.valid"
            class="btn btn-success btn-wide btn-lg">{{ 'lang.globals.submit' | translate }}
    </button>
  </div>
</form>
